"use client"

import { useState } from "react"
import { ArrowLeft, X } from "lucide-react"
import { useNavigate, useLocation } from "react-router-dom"
import { useSwipeable } from "react-swipeable"
import AdCard from "./AdCard"

export default function MobileImageGallery() {
  const navigate = useNavigate()
  const location = useLocation()
  const [selectedImageIndex, setSelectedImageIndex] = useState(null)

  const images = location.state?.images || []
  const villaName = location.state?.villaName || ""
  const guestCount = location.state?.guestCount || 0
  const bedrooms = location.state?.bedrooms || 0
  const totalVillaArea = location.state?.totalVillaArea || 0

  // Define swipe handlers at the top level
  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => {
      if (selectedImageIndex !== null && selectedImageIndex < images.length - 1) {
        setSelectedImageIndex(selectedImageIndex + 1)
      }
    },
    onSwipedRight: () => {
      if (selectedImageIndex !== null && selectedImageIndex > 0) {
        setSelectedImageIndex(selectedImageIndex - 1)
      }
    },
  })

  const handleImageClick = (index) => {
    setSelectedImageIndex(index)
  }

  const closeFullscreen = () => {
    setSelectedImageIndex(null)
  }

  return (
    <div className="min-h-screen bg-black/10">
      {selectedImageIndex !== null ? (
        // Fullscreen image view with swipe functionality
        <div className="fixed inset-0 z-50 bg-black flex items-center justify-center">
          <button onClick={closeFullscreen} className="absolute top-4 right-4 z-50 p-2 bg-black/50 rounded-full">
            <X className="h-6 w-6 text-white" />
          </button>
          <div
            className="h-full w-full flex items-center justify-center"
            {...swipeHandlers} // Apply swipe handlers here
          >
            <img
              src={images[selectedImageIndex] || "/placeholder.svg"}
              alt={`Villa image ${selectedImageIndex + 1}`}
              className="max-h-full max-w-full object-contain"
            />
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 text-white">
              {selectedImageIndex + 1} / {images.length}
            </div>
          </div>
        </div>
      ) : (
        // Grid view
        <>
          <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b">
            <div className="container mx-auto px-4 py-4">
              <div className="flex items-center gap-4">
                <button
                  onClick={() => navigate(-1)}
                  className="flex items-center justify-center w-10 h-10 rounded-full hover:bg-gray-100"
                >
                  <ArrowLeft className="h-6 w-6" />
                </button>
                <div className="flex-1">
                  <h1 className="text-xl font-bold text-black truncate">{villaName}</h1>
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <span>{guestCount} Guests</span>
                    <span className="w-1 h-1 bg-gray-300 rounded-full"></span>
                    <span>{bedrooms} Bedrooms</span>
                    <span className="w-1 h-1 bg-gray-300 rounded-full"></span>
                    <span>{totalVillaArea} m²</span>
                  </div>
                </div>
              </div>
            </div>
          </header>

          <div className="pt-24 px-4">
            <div className="mb-6 w-full">
                    <AdCard
                      adSlot="5041443228"
                        className="w-full h-[100px] sm:h-[110px] md:h-[248px] lg:h-[248px]  
                          mx-auto rounded-xl transition-all duration-300"
                    />
                  </div>
            {images.length === 0 ? (
              <div className="flex items-center justify-center h-[calc(100vh-64px)] text-white">
                <p>No images available</p>
              </div>
            ) : (
              <div className="grid grid-cols-2 gap-4">
                {images.map((image, index) => (
                  <div
                    key={index}
                    onClick={() => handleImageClick(index)}
                    className="aspect-square rounded-2xl overflow-hidden cursor-pointer"
                  >
                    <img
                      src={image || "/placeholder.svg"}
                      alt={`Villa image ${index + 1}`}
                      className="w-full h-full object-cover"
                      loading="lazy"
                      onError={(e) => {
                        e.target.src = "/placeholder.svg"
                      }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  )
}
<div className="mb-6 w-full">
                    <AdCard
                      adSlot="5041443228"
                        className="w-full h-[100px] sm:h-[110px] md:h-[248px] lg:h-[248px]  
                          mx-auto rounded-xl transition-all duration-300"
                    />
                  </div>